import { useContext, useMemo } from 'react'
import type { JSX } from 'react'
import StringValue from '../String'
import type { Path, ValueProps } from '../../types'
import { useValueProps } from '../../hooks'
import useDataValue from '../../hooks/useDataValue'
import Context from '../../DataContext/Context'
import { convertJsxToString } from '../../../../shared/component-helper'
import type { Data } from '../../Field/Selection'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type ValueSelectionProps = ValueProps<string> & {
  dataPath?: Path
}

function Selection(props: ValueSelectionProps) {
  const { fieldInternalsRef } = useContext(Context) || {}
  const { path, dataPath, value, ...rest } = useValueProps(props)
  const { value: dataPathValue } = useDataValue<Data>(
    dataPath,
    undefined,
    {
      pathType: 'absolute',
    }
  )

  const valueToDisplay = useMemo<string | undefined>(() => {
    const fieldProp = fieldInternalsRef?.current?.[path]?.props

    if (path || dataPath) {
      let list = dataPathValue?.map?.((props) => ({ props }))

      if (!list) {
        list = fieldProp?.children as Array<
          Omit<JSX.Element, 'props'> & { props: Data[number] }
        >
      }

      const title = list?.find?.((child) => child.props.value === value)
        ?.props?.title

      return title ? convertJsxToString(title) : value
    }

    return value
  }, [dataPath, dataPathValue, fieldInternalsRef, path, value])

  return <StringValue value={valueToDisplay} path={path} {...rest} />
}

withComponentMarkers(Selection, {
  _supportsSpacingProps: true,
})

export default Selection
